import React, { useState, useEffect } from 'react'

function CustomerProfile({ profile, setProfile }) {
    const [fullName, setFullName] = useState('')
    const [email, setEmail] = useState('')

    useEffect(() => {
        if (profile) {
            setFullName(profile.full_name || '')
            setEmail(profile.email || '')
        } else {
            setFullName('')
            setEmail('')
        }
    }, [profile])

    const handleBlur = () => {
        setProfile(prev => ({
            ...prev,
            full_name: fullName.trim(),
            email: email.trim()
        }))
    }

    return (
        <div>
            <form className="flex flex-col md:flex-row gap-4">
                <div className="form-control w-full">
                    <label className="label">
                        <span className="label-text">Email: *</span>
                    </label>
                    <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onBlur={handleBlur}
                        type="email"
                        name="email"
                        required
                        className="input input-bordered w-full"
                    />
                </div>
                <div className="form-control w-full">
                    <label className="label">
                        <span className="label-text">Full Name: *</span>
                    </label>
                    <input
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        onBlur={handleBlur}
                        type="text"
                        name="fullname"
                        required
                        className="input input-bordered w-full"
                    />
                </div>
            </form>
        </div>
    )
}

export default CustomerProfile